<div checkoutCy="modal_prices_compatibility">
    <div class="is-flex is-centered">
        <span class="icon is-huge">
            <i class="tri-exclamation-circle"></i>
        </span>
    </div>
    <p>
        Nous sommes désolés mais vous ne pouvez pas cumuler {{ labelsAdd[0] }} et
        <span>{{ labelsKeep[0] }} sur cet achat.</span>
    </p>
    <div class="divider has-background-white"></div>
    <p class="has-text-weight-bold is-size-5">Que voulez-vous conserver ?</p>
    <div class="checkbox">
        <input
            class="input is-checkradio"
            type="radio"
            [formControl]="actionsControl"
            name="add"
            [value]="false"
            id="continue"
            required
            checkoutCy="modal_prices_compatibility_edp_choice"
            style="width: fit-content"
        />
        <label class="checkbox-label" for="continue">{{ labelsKeep[1] }}</label>
    </div>
    <div class="checkbox">
        <input
            class="input is-checkradio"
            type="radio"
            [formControl]="actionsControl"
            name="add"
            [value]="true"
            id="add"
            required
            checkoutCy="modal_prices_compatibility_promocode_choice"
            style="width: fit-content"
        />
        <label class="checkbox-label" for="add">{{ labelsAdd[1] }}</label>
    </div>
    <ng-template #customModalFooter>
        <button checkoutCy="modal_prices_compatibility_confirm" class="button is-conversion" (click)="validate()">
            Confirmer
        </button>
    </ng-template>
</div>
